import React from 'react';
import TableWidget from './TableWidget';

export default function PatientFormsWidget(props) {
  return <TableWidget {...props} />;
}
